import {
  Button,
  Grid,
  Paper,
  Typography,
  // Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PropsWithChildren, useState } from "react";
import { styles } from "../../../theme";
import PopUp from "./PopUp";
import { Icon } from "./Icon";
// import hero from "../../../medias/hero.webp";

interface Props {
  pathName?: string;
  children?: React.ReactNode;
  title?: string;
  description?: string[];
  style?: React.CSSProperties;
  md: number;
  xs: number;
  button?: string;
}

export const CardPopUp = ({
  pathName,
  children,
  title,
  description,
  style,
  md,
  xs,
  button,
}: PropsWithChildren<Props>) => {
  // let heroImage;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [openDialog, setOpenDialog] = useState(false);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  // // Verifica se pathName foi fornecido e tenta importar dinamicamente a imagem
  // if (pathName)
  //   try {
  //     heroImage = require(`../../../medias/${pathName}`);
  //   } catch (error) {
  //     console.error("Erro ao carregar a imagem:", error);
  //   }
  // // else heroImage = hero;

  return (
    <Grid item md={md} xs={xs} spacing={0} style={{ padding: 0 }}>
      <Paper
        style={
          isDesktop
            ? { ...styles.card }
            : { ...styles.card, ...styles.mobileCard }
        }
      >
        {/* {heroImage && (
          <img
            src={heroImage}
            style={{
              borderRadius: "50%",
            }}
            alt="Imagem"
          />
        )} */}
        <Icon />
        <Typography
          variant="h5"
          style={{
            padding: "0",
            marginLeft: "10%",
            marginRight: "10%",
            // alignItems: "center",
            // justifyContent: "center",
            width: "90%",
            height: "auto",
            display: "block",
            textAlign: "justify",
            // height: "100%",
            fontFamily: "Copperplate Copperplate-Gothic-Light sans-serif",
          }}
        >
          <label style={styles.label}>{title}</label>
        </Typography>
        {description &&
          description.map((item, index) => (
            <Typography
              key={index} // Use uma chave única para ajudar o React a identificar quais itens mudaram, foram adicionados ou removidos
              variant="body1"
              style={{
                padding: "0",
                color: "#353740",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
              }}
            >
              {item}
            </Typography>
          ))}
        {button && <Button onClick={handleClickOpen}>{button}</Button>}

        <PopUp
          open={openDialog}
          onClose={handleClose}
          title="Título do Popup"
          // content={
          //   <Typography variant="body1">
          //     Este é o conteúdo do popup. Você pode adicionar mais informações
          //     aqui.
          //   </Typography>
          // }
          actions={
            <>
              <Button onClick={handleClose}>Fechar</Button>
              {/* Adicione outros botões de ação se necessário */}
            </>
          }
        />
      </Paper>
    </Grid>
  );
};
